import { gql, useQuery } from "@apollo/client";

const GET_CURRENT_USER_CLINIC = gql`
  query getCurrentUserClinic {
    currentUserClinic {
      id
      name
      featureFlags
    }
  }
`;

interface CurrentUserClinic {
  id: string;
  name: string;
  featureFlags: string[];
}

interface GetCurrentUserClinicResponse {
  currentUserClinic: CurrentUserClinic;
}

export const useCurrentUserClinic = () => {
  const { data, ...rest } = useQuery<GetCurrentUserClinicResponse>(GET_CURRENT_USER_CLINIC);

  return {
    clinic: data?.currentUserClinic,
    ...rest,
  };
};
